<template>
	<b-row id="ObjectDashAdminContainer" class="w-100 h-100">
		<!-- Colonne TYPE OBJET : arborescence des types objets avec dashboards objets existants -->
		<b-col id="colType" xs="1" sm="6" md="4" lg="4" xl="3" class="h-100">
			<b-card no-body :header="$t('ObjectType')" align="center" class="font-weight-bold d-flex flex-column mh-100 h-100">
				<b-list-group id="adminList" flush class="p-0 flex-grow-1 w-100 overflow-auto">
					<!-- Arborescence -->
					<DashTree :ChildNodes="adminTree" class="p-2 font-weight-normal" align="left" :Action="Action"/>
				</b-list-group>
			</b-card>
		</b-col>

		<!-- Colonne DASHBOARD : affichage du tableau de bord et de ses paramétrages -->
		<b-col id="dashboard" class="w-100 h-100 p-0" xs="3" sm="6" md="8" lg="8" xl="9">
			<!-- Paramètrage du tableau de bord-->
			<b-card no-body :header="$t('Dashboard')" header-class="text-center font-weight-bold" class=" h-100">
				<b-row cols="12" class="pt-2">
					<!-- Nom du tableau de bord-->
					<b-col cols="4">
						<b-form-group class="px-3 py-0" :label="$t('LabelNameDashboard')" label-for="civility-input" :label-cols="4" >
							<!-- Hauteur de la zone de saisie de nom fixée à 43px pour être uniforme avec les multiselect à côté (pas réussi à reduire leur hauteur...) -->
							<b-form-input v-model="lDashboard.Name" :disabled="!$store.getters['CheckAction']('Write', undefined, Action) || !canConfigDash" :state="isValidName"  />
							<b-form-invalid-feedback :state="isValidName">
								<!-- $t('EnterDashName') / Veuillez saisir un nom de tableau de bord objet -->
								{{ $t('EnterDashName') }}
							</b-form-invalid-feedback>  
						</b-form-group>
					</b-col>
					<!-- S'il ne s'agit pas d'un tableau de bord par défaut ==> Sélection des profiles obligatoire et éventuellement des noeuds -->
					<!--Zone de sélection du ou des profils du dashboard-->
					<b-col cols="8" v-if="canConfigDash" >
						<b-form-group :label="$t('LabelUserProfile')" label-for="civility-input" :label-cols="2" class="pr-2">
							<multiselect v-model="selectedProfiles"
								:options="getListItem(PROFILES_LIST_NAME)"
								:multiple="true"
								:close-on-select="false"
								:clear-on-select="false"
								:preserve-search="true"
								:searchable="false"
								:show-labels="false"
								:allow-empty="true"
								:disabled="!$store.getters['CheckAction']('Write', undefined, Action) || Object.keys(dashNode).length == 0"
								label="Label"
								track-by="Id" 
								:placeholder="$t('PleaseSelectProfile')"
								>
								<!-- <template #option="{props}">
									<div class="option__desc"><span class="option__small">{{ props.option.Label }}</span></div>
								</template> -->
								<template #caret={toggle}>
									<span class="multiselect__select pr-0">
										<b-icon icon="chevron-down" font-scale="0.55" shift-h="7" style="stroke: black !important; stroke-width: 1.5px !important;"/>
									</span>
								</template>
							</multiselect>
						</b-form-group>
					</b-col>
				</b-row>

				<b-row v-if="canConfigDash">
					<b-col>
						<span class="pl-3">
							{{ $t('LabelObjectTypeNode') }}
							<b-button variant="outline-dark" :pressed="showAssetSelector" :disabled="!$store.getters['CheckAction']('Write', undefined, Action) || !canConfigDash || !isTreeLoaded" @click="showAssetSelector = !showAssetSelector" class="btn-circle border-0 pl-2"
								v-b-tooltip.noninteractive.hover :title="!isTreeLoaded ? $t('LoadTree') : $t('LabelObjectTypeNode')">
								<b-icon icon="diagram3"  />
							</b-button>
						</span>
					</b-col >
					<b-col cols="9" v-if="!showAssetSelector ">
						<Pins :Variant="Variant" :FilterTreeStore="filterTreeStore" :ObjectType="lDashboard.ObjectType" :ShowSave="false" :Disabled="!$store.getters['CheckAction']('Write', undefined, Action)" />
					</b-col>
				</b-row>

				<hr class="pt-2 pb-0 mt-2 mb-0" />

				<!--Partie AFFICHAGE DU DASHBOARD-->
				<template v-if="!showAssetSelector">
					<!-- BARRE DE BOUTONS -->
					<b-row class="pt-0">
						<b-col cols="3" >
							<b-button-toolbar key-nav :aria-label="$t('ToolBarButtons')">
								<!--Sauvegarde dashboard-->
								<b-button-group  class="mx-1">
									<b-avatar @click="save()" :title="$t('Save')" :variant="Variant" button button-type="submit" badge-top 
										badge-variant="info" badge-class="bg-transparent p-0" size="2rem"
										:disabled="!canConfigDash || !$store.getters['CheckAction']('Write', undefined, Action)">
										<template #default>
											<i class="bi bi-floppy" />
										</template>
										<template #badge v-if="isModified">
											<!-- WarnUpdatedFields : Des champs ont été modifiés -->
											<b-icon v-if="isModified"
												v-b-tooltip.noninteractive.hover :title="$t('WarnUpdatedFields')" icon="exclamation" variant="light" />
										</template>
									</b-avatar>
								</b-button-group>
								<b-button-group class="mx-1">
									<!--Ajout widget-->
									<!-- $t('AddWidget') / Ajouter un widget -->
									<b-button @click="displayWidgetsLib = !displayWidgetsLib" v-b-tooltip.hover :title="$t('AddWidget')" :disabled="!$store.getters['CheckAction']('Add', undefined, Action) || !canConfigDash" class="btn-circle"  :variant="'outline-' + Variant"><b-icon icon="plus" /></b-button>
								</b-button-group>
							</b-button-toolbar>
						</b-col>
						<b-col cols="9" >
							<!--Passage en mode plein écran du dashboard-->
						</b-col>
					</b-row>

					<hr class="py-1 my-1" />

					<b-row class="d-flex flex-column mh-100 h-100 overflow-auto">
						<b-col class="flex-grow-1 overflow-auto bg-white">
							<grid-layout 
								:id="dashboardTypeEnum[dashboardType].toString() + lDashboard.Id"
								:ref="dashboardTypeEnum[dashboardType].toString() + lDashboard.Id"
								:layout.sync="lDashboard.Widgets"
								:col-num="colNum"
								:row-height="30"
								:is-draggable="true"
								:is-resizable="true"
								:is-mirrored="false"
								:margin="[10, 10]"
								:use-css-transforms="false"
								:responsive="false"
								:vertical-compact="false"
								:prevent-collision="true"
								:autoSize="true"
								class="h-100 w-100">
								<!-- Si des widgets existent sur le tableau de bord -->
								<template v-if="lDashboard && objectDashboard.Widgets && lDashboard.Widgets.length > 0">
									<grid-item :ref="dashboardType.toString() + lDashboard.Id + 'widget' + widget.i" v-for="widget in lDashboard.Widgets" :key="widget.Id"
										:x="widget.x" :y="widget.y" :w="widget.w" :h="widget.h" :i="widget.i"
										:minW="widgetLibrary(widgetTypeEnum[widget.Type])?.MinW"
										:minH="widget.minH" :maxH="widget.maxH"
										:static="!($store.getters['CheckAction']('Write', undefined, Action))"
										drag-allow-from=".vue-draggable-handle" drag-ignore-from=".no-drag">
										<WidgetContainer :DashboardId="lDashboard.Id" :WidgetId="widget.Id" :Title="widget.Name" 
											:WidgetLibrary="widgetLibrary(widgetTypeEnum[widget.Type])" 
											:TargetDashboard="dashboardType" 
											:Parameters="widget.Parameters" :Preview="true" :InError="widget.InError" :Action="Action"
											:ObjectType="objectType"
											:AutoSize="true" :EditMode="$store.getters['CheckAction']('Write', undefined, Action)" :DisplayConfigButton="true" :DisplayExportButton="false" :DisplayNodesConfig="false"
											@RemoveWidgetEvent="removeWidget(widget.i)" />
									</grid-item>
								</template>

								<!-- Rendu lorsqu'aucun widget n'est présent sur le tableau de bord -->
								<grid-item v-else :x=0 :y=0 :w=2 :h=6 :i="1" :key="1" static class="rounded" :style="'border: 2px dashed var(--' + Variant + ');'">
									<b-container class="h-100">
										<b-row class="justify-content-center h-100 align-items-center"><b-col class="align-self-center">
											<b-row><b-col class="text-center text-gray-dark"><b-icon icon="grid" font-scale="2" /></b-col></b-row>
											<!-- $t('AddFirstWidget') / Ajouter votre premier widget pour compléter le tableau de bord -->
											<b-row><b-col class="text-center py-3 px-5 text-gray-dark">{{ $t('AddFirstWidget') }}</b-col></b-row>
										</b-col></b-row>
									</b-container>
								</grid-item>
							</grid-layout>
						</b-col>
					</b-row>
				</template>

				<!-- Selecteur de pins-->
				<HeritageNodeSelector v-if="showAssetSelector" :SelectorTitle="$t('AvailableAssets')" :SelectorSubTitle="$t('SelectNodeForUser')" :PinsDisplayerTitle="$t('ConnectedAssets')"
					class="pl-1 pr-0 h-100 w-100" :FilterTreeStore="filterTreeStore" :PinsSelected.sync="lDashboard.Pins" :Variant="Variant"/>

				<!-- Bibliothèque de widgets -->
				<WidgetLibrary v-model="selectedWidget" :Right="false" :DisplayWidgetsLib="displayWidgetsLib" :DashboardType="dashboardType" :ObjectType="objectType" :Top="getTop('ObjectDashAdminContainer')"
					@AddWidgetEvent="addWidget(true)" @DragStartEvent="dragstart" @DragEvent="drag" @DragEndEvent="dragend" />
			</b-card>
		</b-col>
	</b-row>
</template>

<script lang="ts">
import { Vue, Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import DashTree from './ObjectDashAdmin/DashTree.vue';
import Multiselect from 'vue-multiselect';
import BaseTreeNode from '@/types/BaseTreeNode';
import DashboardTypeEnum from '@/enums/DashboardTypeEnum';
import locales from './locales/ObjectDashAdmin.json';
import { API_URL, MAIN_FILTER_TREE, SELECTOR_FILTER_TREE } from '@/App.settings';
import SelectModeEnum from '@/enums/SelectModeEnum';
import ListItem from '@/types/fields/ListItem';
import ObjectDashboard from '@/types/Dashboard/ObjectDashboard/ObjectDashboard';
import Dashboard from '@/components/commons/Dashboard';
import HeritageTree from '@/components/commons/HeritageTree.vue';
import Pins from '@/components/commons/Pins.vue';
import NodeTypeEnum from '@/enums/NodeTypeEnum';
import IConfigTree from '@/interfaces/IConfigTree';
import TreeNode from '@/types/TreeNode';
import Dictionary from '@/types/Dictionary';
import axios, { AxiosResponse } from 'axios';
import { FilterTreeBuilder } from '@/components/commons/FilterTreeBuilder';
import { EMPTY_OBJECT_DASHBOARD_ID } from '@/store/ObjectDashboard/IObjectDashAdminState';
import HeritageNodeSelector from '@/components/commons/HeritageTree/HeritageNodeSelector.vue';
import { CompareUtils } from '@/components/commons/Utils';
import { error } from 'pdf-lib';

/** 
 * Administration des tableaux de bord objet 
 * 
 * Etape de validation d'un tableau de bord
 * 	- Arrivé sur la page d'administration (aucun tableau de bord)
 * 	- Selection du noeud d'objet type ou clique sur '+' d'un objet type
 * 		- Si clique sur le '+' alors création d'un tableau du type propriétaire du '+'
 * 		- Si clique sur un tableau spécifique existant ( récupération du tableau spécifique)
 * 	- Saisie des paramètres du tableau de bord (nom uniquement ou nom avec profile utilisateur ou/et pins)
 * 	- Ajout de widget ou sauvegarde
 */
@Component({
	components: {
		Multiselect,
		DashTree,
		HeritageTree,
		Pins,
		HeritageNodeSelector
	},
	i18n:{messages: locales}
})
export default class ObjectDashAdmin extends Dashboard<ObjectDashboard> {
	//#region DECLARATION UTILITAIRES (FilterTree name, listItem name, dashboardType, enums, ...)
	/** Indique le nom du nouveau store Vuex à instancier pour le sélecteur */
	private filterTreeStore: string = SELECTOR_FILTER_TREE + 'ObjectDashAdmin';
	
    /** Builder d'instance d'arborescence */
    private filterTreeBuilder!: FilterTreeBuilder;

	/** Nom de la liste à interroger côté server pour obtenir les types de contacts */
	private readonly PROFILES_LIST_NAME: string  = "Profiles";
	
	/** Type de dashboard pour spécifié avec quel store VueX communiquer dans BaseDashboard */
	protected readonly dashboardType: DashboardTypeEnum = DashboardTypeEnum.Object;

	/** Initialisation dur Tableau de bord local synchronisé avec le vue-grid-layout */
	protected lDashboard: ObjectDashboard = {
		Name: "",
		Id: EMPTY_OBJECT_DASHBOARD_ID,
		ObjectType: "",
		Pins: [],
		Widgets:[],
		ProfileIds: []
	} as ObjectDashboard;

	private copylDashboard: ObjectDashboard = {
		Name: "",
		Id: EMPTY_OBJECT_DASHBOARD_ID,
		ObjectType: "",
		Pins: [],
		Widgets:[],
		ProfileIds: []
	} as ObjectDashboard;

	//#endregion
	
	//#region PROPERTIES
	/** Droit disponible pour l'utilisateur en cours */
	@Prop()
	public Action!: string;

	/** Arborescence */
	@Getter('ObjectDashboardStore/GetAdminTree')
	private adminTree!: BaseTreeNode[];

	/** Profils disponible pour la selection de profils utilisateur */
	@Getter('GetListItems')
	private getListItem!: (listName: string) => ListItem[];

	/** Renvoi le noeud sélectionné dans l'arborescence */
	@Getter('ObjectDashboardStore/GetDashNode')
	private dashNode!: BaseTreeNode;

	/** ObjectDashboard associé au noeud qui a été sélectionné */
	@Getter('ObjectDashboardStore/GetObjectDash')
	private objectDashboard!: ObjectDashboard;

	@Getter('ObjectDashboardStore/GetIsModified')
	private isModified!: boolean;
	//#endregion

	/** Indique si l'on peux saisir les paramètres du tableau de bord en cours de selection */
	private canConfigDash: boolean = false

	/** Réinitialise le composant */
	private reset(){
		// Partie INPUT CONFIG
		this.canConfigDash = false;
		// Purge les profiles utilisateur saisie
		// this.selectedProfiles.splice(0, this.selectedProfiles.length)

		// Reset les validateurs
		this.isValidName = null;

		// Partie SELECTION
		// Purge la selection
		this.lDashboard = {
			Name: "",
			Id: EMPTY_OBJECT_DASHBOARD_ID,
			ObjectType: "",
			Pins: [],
			Widgets:[],
			ProfileIds: []
		} as ObjectDashboard
		this.copylDashboard = CompareUtils.Clone(this.lDashboard);
		this.objectType = ""
	}

	/** Observateur de changement sur le tableau de bord en cour de selection */
	@Watch('objectDashboard', { immediate: false })
	private async onChangeDashboard(newVal: ObjectDashboard, oldVal: ObjectDashboard) {
		this.showAssetSelector = false;
		if(oldVal !== newVal){
			// On ne peux configurer un tableau que si le noeud selectionné est un tableau
			if(this.dashNode.Nodetype === NodeTypeEnum.Dashboard){
				if(newVal && this.dashNode){
					this.objectType = this.dashNode.ObjectType;
					await this.loadDashboard(newVal);
					this.lDashboard = newVal;
					this.lDashboard.Pins = this.lDashboard.Pins.sort();
					this.lDashboard.ProfileIds = this.lDashboard.ProfileIds.sort();
					this.lDashboard.Widgets = this.lDashboard.Widgets.sort();

					this.copylDashboard = CompareUtils.Clone(newVal);
					this.copylDashboard.Pins = this.copylDashboard.Pins.sort();
					this.copylDashboard.ProfileIds = this.copylDashboard.ProfileIds.sort();
					this.copylDashboard.Widgets = this.copylDashboard.Widgets.sort();
				}
			} else {
				this.reset();
				this.canConfigDash = false;
			}
		}
	}

	/** Observateur de changement sur les changements du champs de selction de profiles utilisateur. */
	@Watch('selectedProfiles', { immediate: true })
	private onChangeSelectedProfiles() {
		this.lDashboard.ProfileIds = this.selectedProfiles.map(item => { return item.Id });
	}

	@Watch('lDashboard',{ deep: true})
	private async onChangelDashboard() {
		/** Tableau de bord vide (noeud sans tableau) */
		if(this.objectDashboard.Id !== EMPTY_OBJECT_DASHBOARD_ID && this.lDashboard.Id === this.objectDashboard.Id ){
			/** Nouveau dashboard ou modification détecté */
			if(this.objectDashboard.Id < 0 || !CompareUtils.EqualsParams(this.copylDashboard, this.objectDashboard, ["Widgets","Pins.*.TreeNode"])){
				await this.$store.dispatch('ObjectDashboardStore/SetIsModified', true);
			}
			else
				await this.$store.dispatch('ObjectDashboardStore/SetIsModified', false);
		} 
	}

	//#region SELECTION
	/** Type d'objet sélectionné dans l'arborescence */
	private objectType: string = ""

	/** Indique que l'arborescence est bien chargé */
	private isTreeLoaded: boolean = false;

	private async loadTree(dashboard: ObjectDashboard, parentsObjectTypes: string[]){
		await this.$store.dispatch(this.filterTreeStore + '/ChangeSelectModeStrategy', { selectMode: SelectModeEnum.MultiAdvanced, configTree:  new ObjectDashConfigTree( parentsObjectTypes ) });
		await this.$store.dispatch(this.filterTreeStore + '/RemoveAllPins');
		if(dashboard && dashboard.Pins && dashboard.Pins.length > 0)
			/** Récupère les nœuds selectionnés */
			await this.$store.dispatch(this.filterTreeStore + '/SetPins', dashboard.Pins);
	}

	/** Charge les données du tableau. */
	private async loadDashboard(dashboard: ObjectDashboard) {
		if(!dashboard)
			return;

		if(dashboard.Id === EMPTY_OBJECT_DASHBOARD_ID)
			return;
		
		try {
			this.isTreeLoaded = false;

			/** Intéroge le serveur pour récupérer les types d'objet enfants potentiel de cet objet type*/
			const args: Dictionary<any> = {};
			args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
			args["ObjectType"] = this.objectType;

			let parentsObjectTypes: string[];
			/** Interroge l'API correspondant au dashboard du dashNode sélectionné */
			const response: AxiosResponse<any,any> = await axios.post(API_URL + "FilterTree/GetParentConstraints", args);
			if (response && response.data)
				parentsObjectTypes = response.data;

			parentsObjectTypes.push(this.objectType.toString())
			await this.$store.dispatch(this.filterTreeStore + '/SetPropertiesFilterObjectTypes', parentsObjectTypes)

			this.loadProfiles(dashboard);

			/** Optimisation pour éviter de charger une arbo pour un tableau vide non destiné à être édité */
			if(dashboard.Id !== EMPTY_OBJECT_DASHBOARD_ID) {
				this.loadTree(dashboard, parentsObjectTypes).then(() => {this.isTreeLoaded = true;}).catch(err => { console.error(err); }); /** Chargement de l'arborescence en détacher de l'éxécution du chargement de ce tableau de bord */
			}
			console.debug("ObjectDashAdmin - dashNodeUpdate() - this.dashNode.Id : ", this.dashNode.Id);

			// Permet la configuration du tableau de bord (nom, etc ...)
			this.canConfigDash = true;
		} catch(err) {
			console.error(err);
			this.$bvToast.toast(this.$t('LoadDashboardError').toString(), { // $t('LoadDashboardError') / Une erreur s'est produite sur le chargement du tableau de bord objet
				title: this.$t('Error').toString(), // $t('Error') / Erreur
				autoHideDelay: 10000,
				variant: "danger",
				solid: true,
				appendToast: true,
				toaster: "b-toaster-top-center"
			});
		}
	}

	/** Charge les profiles utilisateurs. */
	private loadProfiles(dashboard: ObjectDashboard) {
		if(dashboard && dashboard.ProfileIds && dashboard.ProfileIds.length > 0){
			// Récupère la liste des profiles utilisateurs disponibles pour ce client
			const profiles = this.getListItem(this.PROFILES_LIST_NAME)
			// Récupère les profiles du tableau de bord
			if (profiles && profiles.length > 0)
				this.selectedProfiles = profiles.filter(clientProfile => dashboard.ProfileIds.includes(clientProfile.Id));
			else
				this.selectedProfiles = []
		}else{
			this.selectedProfiles = []
		}
	}

	//#endregion

	//#region INPUT CONFIG DASHBOARD
	/** Profils utilisateurs sélectionnés */
	private selectedProfiles: ListItem[] = [];

	/** Affiche le selecteur de pins */
	private showAssetSelector: boolean = false

	/** Indicateur de validité sur la saisie du nom du dashboard */
	private isValidName: boolean | null = null;

	/** Retourne la validation du nom du dashboard */
	private validName(): boolean | null { return (!this.lDashboard.Name || ((this.lDashboard.Name as string).trim() === '') ? false : null) }
	//#endregion

	//#region SAVE AND WIDGETS
	/** Enregistrement du tableau de bord objet */
	private async save() {
		// Vérifie si un nom de dashboard objet a bien été saisi.
		this.isValidName = this.validName();

		if (this.isValidName == false ) {
			this.$bvToast.toast(this.$t('MissingInformation').toString(), { // $t('MissingInformation') / Des informations sont manquantes
				title: this.$t('Error').toString(), // $t('Error') / Erreur
				// autoHideDelay: 5000,
				variant: "danger",
				solid: true,
				appendToast: true,
				toaster: "b-toaster-top-center"
			});
		}
		else {
			try{
				this.$store.dispatch("ShowLoadingMask", this.$t('SaveDashboardLoading'));     // "Identification en cours"

				this.lDashboard.Pins = this.$store.getters[this.filterTreeStore + '/GetPins'];
				// Sauvegarde des dashboards existants
				await this.$store.dispatch("ObjectDashboardStore/Save", { dashboard: this.lDashboard} )
				this.$bvToast.toast(this.$t('SaveDashboard').toString(), { // $t('SaveDashboard') / Le tableau de bord objet a été enregistré avec succès.
					title: this.$t('RecordingObjectDashboard').toString(), // $t('RecordingObjectDashboard') / Enregistrement du tableau de bord objet
					autoHideDelay: 3000,
					variant: "success",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			} catch(err) {
				if (err.response.status === 409) {
					this.$bvToast.toast(this.$t('SaveConflictError').toString(), { // $t('AnErrorOccured') / "Une erreur s'est produite."
						title: this.$t('Error').toString(), // $t('Error') / Erreur
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				}else{
					console.error(err);
					this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { // $t('AnErrorOccured') / "Une erreur s'est produite."
						title: this.$t('Error').toString(), // $t('Error') / Erreur
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				}
			} finally {
				this.$store.dispatch("HideLoadingMask", {});
			}
		}
	}
	//#endregion
	
	// Exécuté à la création avant la génération du DOM
	async created(){
		// Par défaut l'auto save des widgets est activé
		this.autoSave = true;
		try{
			// Chargement de l'arborescence de types d'objets avec les dashboards existants
			await this.$store.dispatch("ObjectDashboardStore/LoadTree");
			/** Chargement des listes : Type d'objet */
			await this.$store.dispatch("LoadListItems", [{ listName: 'ObjectType' }]);

			this.filterTreeBuilder = new FilterTreeBuilder(this.$store, this.filterTreeStore);
			await this.filterTreeBuilder.Clone(MAIN_FILTER_TREE, [], undefined, SelectModeEnum.MultiAdvanced);

		} catch(err) {
			console.error(err);
			this.$bvToast.toast(this.$t('LoadTreeStructureError').toString(), { // $t('LoadTreeStructureError') / "Une erreur s'est produite sur la chargement de l'arborescence des tableaux de bord objet"
				title: this.$t('Error').toString(), // $t('Error') / Erreur
				autoHideDelay: 10000,
				variant: "danger",
				solid: true,
				appendToast: true,
				toaster: "b-toaster-top-center"
			});
		}

		// Récupère la liste des profiles utilisateurs disponibles pour ce client
		const profiles = this.getListItem(this.PROFILES_LIST_NAME)

		// Chargement de la liste des profils (si pas déjà chargée)
		if (!profiles || (profiles && profiles.length < 1 )) {
			await this.$store.dispatch("LoadListItems", [{ listName: this.PROFILES_LIST_NAME }]).then(response => {
				console.debug("ObjectDashAdmin- created() - LoadListItems (after) - x.ListName : %O - Chargement de la liste des ListItems terminée", this.PROFILES_LIST_NAME);
			})
			.catch(err => {
				console.error(err);
				this.$bvToast.toast(this.$t('ProfilsError').toString(), { // $t('ProfilsError') / "Une erreur s'est produite sur la chargement de la liste des profils."
					title: this.$t('Error').toString(), // $t('Error') / Erreur
					autoHideDelay: 10000,
					variant: "danger",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			});
		}
	}

    async beforeDestroy() {
		// Nettoyage de la selection
		await this.$store.dispatch("ObjectDashboardStore/Reset",{} as BaseTreeNode);

        if (this.filterTreeBuilder)
            this.filterTreeBuilder.UnloadFilterTree();
    }
}

/** Implémentation de IConfigTree pour filtrer la liste des noeuds de l'arborescence à sa création spécifiquement pour les m'administration des tableaux d'objets */
class ObjectDashConfigTree implements IConfigTree {
	/** Object type à afficher */
	private witheListObjectTypes: string[] = [];

	/** 
	 * Initialisation de ObjectDashConfigTree
	 * @param whiteListObjectTypes Type d'objet à filtrer
	 */
	public constructor(whiteListObjectTypes: string[]) {
		this.witheListObjectTypes = whiteListObjectTypes;
	}

	/** 
	 * Filtre une liste de noeuds
	 * @param treeNodes Noeuds à filtrer
	 * @param isHistoricMode Indication mode historique
	 * @returns         Noeuds filtrés
	 */
	public Filter(treeNodes: TreeNode[], isHistoricMode: boolean): TreeNode[] {
		console.debug("ObjectDashAdmin - Filter() - treeNodes : ", treeNodes);

		if (!treeNodes || treeNodes.length === 0) return [];

		// Marque Hidden et prépare compteur d'enfants visibles
		const visibleChildCount = new Array<number>(treeNodes.length).fill(0);

		for (let treeNode of treeNodes) {
			treeNode.Hidden = (treeNode.Depreciated && !isHistoricMode) || !this.witheListObjectTypes.includes(treeNode.ObjectType);
			treeNode.HiddenCaret = true; // valeur par défaut ; on remettra à false si a enfant visible
		}

		/** On suppose que TreeNodes est trié par LeftBound */

		/** Pile contenant indices des ancêtres (par ordre ascendant de profondeur) */ 
		const ancesterStack: number[] = [];

		for (let index = 0; index < treeNodes.length; index++) {
			const treeNode = treeNodes[index];

			/** Pop tant que le sommet de pile n'est plus ancêtre de node (Pop = récupération destructive du dernière élément)*/
			while (ancesterStack.length > 0) {
				const topIdx = ancesterStack[ancesterStack.length - 1]; /** Effecture un peek pour consulter le noeud ancêtre au sommet de la pile */
				const top = treeNodes[topIdx]; /** récupère l'ancêtre présumé */
				if (top.RightBound > treeNode.LeftBound) break; 
					ancesterStack.pop(); /** Si le noeud n'est pas l'ancêtre du noeud en cours on le supprime */
			}

			/** Si la pile n'est pas vide, le parent immédiat est le top */
			if (ancesterStack.length > 0) {
				const parentIdx = ancesterStack[ancesterStack.length - 1];
				// Si ce node est visible, incrémente le compteur d'enfants visibles du parent
				if (!treeNode.Hidden) visibleChildCount[parentIdx]++;
			}

			/** Empile le node comme possible parent pour futurs nœuds */
			ancesterStack.push(index);
		}

		/** Applique HiddenCaret : true si pas d'enfants visibles */
		for (let i = 0; i < treeNodes.length; i++) {
			treeNodes[i].HiddenCaret = visibleChildCount[i] === 0;
		}

		console.debug("ObjectDashAdmin - Filter() - filteredNodes : ", treeNodes)

		// Retourne l'arbre avec les noeuds masqué si filtré
		return treeNodes;
	}
}
</script>

<style scoped>
	/** Styles utilisés par le Vue-Grid-Layout définis dans App.vue */

	/** Redéfini la couleur d'ombre derrière le déplacement d'un widget */
	:deep(.container .vue-grid-item.vue-grid-placeholder) {
		background: orange !important;
	}

	:deep(.vue-grid-item.vue-grid-placeholder) {
        background: orange !important;
    }
</style>